import { combineReducers } from "redux";
import auth from "./authReducer";

import entities from "./entities";
import ui from "./ui";
import compose from "pages/Mail/Compose/store/composeReducer";
import layout from "layout/store/layoutReducer";
import folders from "pages/Folders/store/foldersReducer";
import quarantine from "pages/Quarantine/store/quarantineReducer";
import log from "pages/Logs/store/logReducer";
import tasks from "pages/Tasks/store/tasksReducer";
import archive from "pages/Archive/store/archiveReducer";
import savedArchiveSearch from "pages/Archive/SavedSearches/store/savedSearchReducer";
import bwlists from "pages/Settings/WhitelistBlacklist/store/bwlistsReducer";
import statistics from "pages/Statistics/store/statisticsReducer";
import signature from "pages/Settings/Signs/store/signatureReducer";
import settings from "./settings";
import calendar from "pages/Calendar/store";
import contacts from "pages/Contacts/store";
import rules from "pages/Settings/Rules/store";
import documents from "pages/Documents/store";
import tags from "pages/Tags/store/tagsReducer";

export default combineReducers({
  auth,
  entities,
  ui,
  compose,
  layout,
  folders,
  quarantine,
  log,
  tags,
  archive,
  savedArchiveSearch,
  bwlists,
  statistics,
  signature,
  settings,
  calendar,
  contacts,
  tasks,
  rules,
  documents
});
